
(function (global) {
  'use strict';

  function resolve(target) {
    if (typeof target === 'string') return document.querySelector(target);
    return target || null;
  }

  function init(target, opts) {
    var root = resolve(target);
    if (!root) return null;
    if (root.__pepHero) return root.__pepHero; 

    opts = opts || {};
    var intervalMs   = opts.intervalMs   || 6000;
    var pauseOnHover = opts.pauseOnHover !== false; 

    var track  = root.querySelector('.pep-hero__track');
    var slides = root.querySelectorAll('.pep-hero__slide');
    var n = slides.length;
    if (!track || n < 2) return null; 

    
    var dotsHost = root.querySelector('.pep-hero__dots');
    if (dotsHost && dotsHost.children.length === 0) {
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.className = 'pep-hero__dot';
        b.setAttribute('type', 'button');
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) b.setAttribute('aria-current', 'true');
        (function (idx) { b.addEventListener('click', function () { go(idx, true); }); })(i);
        dotsHost.appendChild(b);
      }
    }
    var dots = dotsHost ? dotsHost.children : [];

    var reduced  = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var paused   = reduced; 

    var idx = 0;
    var timer = null;

    function render() {
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      for (var i = 0; i < dots.length; i++) {
        if (i === idx) dots[i].setAttribute('aria-current', 'true');
        else dots[i].removeAttribute('aria-current');
      }
      for (var j = 0; j < slides.length; j++) {
        
        slides[j].setAttribute('aria-hidden', j === idx ? 'false' : 'true');
      }
    }

    function go(to, manual) {
      idx = ((to % n) + n) % n;
      render();
      if (manual) restart();
    }
    function next() { go(idx + 1); }
    function prev() { go(idx - 1); }

    function start() {
      stop();
      if (paused || reduced) return;
      timer = setInterval(next, intervalMs);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function restart() { if (!paused) start(); }

    function setPaused(v) {
      paused = !!v;
      if (paused) stop(); else start();
    }

    
    var main = root.querySelector('.pep-hero__main');
    if (pauseOnHover && main) {
      main.addEventListener('mouseenter', stop);
      main.addEventListener('mouseleave', function () { if (!paused) start(); });
      main.addEventListener('focusin', stop);
      main.addEventListener('focusout', function () { if (!paused) start(); });
    }

    
    if (main) {
      main.setAttribute('tabindex', '0');
      main.setAttribute('role', 'region');
      main.setAttribute('aria-roledescription', 'carousel');
      main.setAttribute('aria-label', 'Featured products');
      main.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); next(); restart(); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); prev(); restart(); }
      });

      /* Touch swipe (mobile): a clear horizontal drag advances the carousel; mostly-vertical
         drags are ignored so the page still scrolls normally. Listeners are passive. */
      var _tsx = 0, _tsy = 0, _tracking = false;
      main.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { _tracking = false; return; }
        _tsx = e.touches[0].clientX; _tsy = e.touches[0].clientY; _tracking = true;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (!_tracking) return; _tracking = false;
        var t = e.changedTouches[0], dx = t.clientX - _tsx, dy = t.clientY - _tsy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) { if (dx < 0) next(); else prev(); restart(); }
      }, { passive: true });
    }

    render();
    start();

    var api = {
      next: next, prev: prev, go: go,
      pause: function () { setPaused(true); },
      play:  function () { setPaused(false); },
      destroy: function () { stop(); root.__pepHero = null; },
      get index() { return idx; },
    };
    root.__pepHero = api;
    return api;
  }

  global.PepHero = { init: init };
})(window);
